import React from 'react';
import { Collapse, CardContent, Button, Typography } from '@material-ui/core';
import cx from 'clsx';
export var QACategory = function (_a) {
    var id = _a.id, title = _a.title, sub = _a.sub, expand = _a.expand, onCategoryClick = _a.onCategoryClick, _b = _a.level, level = _b === void 0 ? 0 : _b, checker = _a.checker;
    var _c = React.useState(expand), expanded = _c[0], setExpanded = _c[1];
    var handleExpandClick = sub && sub.length > 0 ? function () { return setExpanded(!expanded); } : function () { return onCategoryClick("category/".concat(id)); };
    return (React.createElement(React.Fragment, null,
        React.createElement(CardContent, { className: cx('faq-category', { 'faq-category-level': level }) },
            React.createElement(Button, { color: expanded ? 'default' : 'secondary', variant: "contained", onClick: handleExpandClick, "aria-expanded": expanded, fullWidth: true, className: cx('faq-category__button', {
                    'faq-has-subcategory': sub && sub.length > 0,
                }), id: id },
                React.createElement(Typography, { className: "faq-category__category", variant: "h4", color: "inherit" }, title))),
        React.createElement(Collapse, { in: expanded, timeout: "auto", unmountOnExit: true }, sub &&
            sub.map(function (v) {
                if (!v) {
                    return null;
                }
                var subCategoryId = v.id || '';
                var subs = v.sub;
                if (subs === null || subs === void 0 ? void 0 : subs.length) {
                    return (React.createElement(QACategory, { key: subCategoryId, id: subCategoryId, title: v.title, sub: v.sub, onCategoryClick: onCategoryClick, level: level + 1, expand: checker(v), checker: checker }));
                }
                var handleCategoryClick = function () { return onCategoryClick("category/".concat(subCategoryId)); };
                return (React.createElement(Button, { fullWidth: true, className: cx('faq-subcategory', 'faq-category__button'), key: subCategoryId, onClick: handleCategoryClick }, v.title));
            }))));
};
//# sourceMappingURL=QACategory.js.map